import {
  API_BASE_URL,
  getDisponibilidadeFrotaPatio as getDisponibilidadeFrotaPatioService,
  getPosicoesSalvasPorPlacas as getPosicoesSalvasPorPlacasService,
  getUltimaPosicaoPorPlaca as getUltimaPosicaoPorPlacaService,
  post
} from '@spark/services';

export const getDisponibilidadeFrotaPatioData = async payload => getDisponibilidadeFrotaPatioService(payload);

export const getPosicoesSalvasPorPlacasData = async (placas, config) => getPosicoesSalvasPorPlacasService(placas, config);

export const getUltimaPosicaoGeralData = async (payload, config) => {
  const response = await post(`${API_BASE_URL}/veiculos/ultima-posicao/geral`, payload || {}, config);
  return response?.data || response || {};
};

export const getUltimaPosicaoPorPlacaData = async (payload, config) => getUltimaPosicaoPorPlacaService(payload, config);

export const exportToExcel = async (rows, fileName, sheetName) => {
  const mod = await import('xlsx');
  const XLSX = mod?.default || mod;

  if (!XLSX?.utils || !XLSX?.writeFile) {
    throw new Error('Biblioteca de exportacao nao disponivel.');
  }

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
};
